import React from "react";
import PublicNav from "../components/PublicNav";
import PublicFooter from "../components/PublicFooter";

const sections = [
  {
    title: "1. Objet",
    body: (
      <>
        Les présentes conditions générales d'utilisation (« CGU ») régissent
        l'accès et l'utilisation du service MmeValentine (le « Service »), une
        plateforme d'activation et de prospection LinkedIn assistée par
        intelligence artificielle. En créant un compte ou en utilisant le
        Service, vous acceptez sans réserve les présentes CGU.
      </>
    ),
  },
  {
    title: "2. Fonctionnement du Service",
    body: (
      <>
        MmeValentine se connecte à votre compte LinkedIn via notre partenaire
        technique <strong>Unipile</strong>, qui fournit un accès sécurisé aux
        fonctionnalités de messagerie et de recherche de LinkedIn. Une fois
        connecté, vous définissez des <strong>segments</strong> (audiences
        cibles) et des instructions ; notre intelligence artificielle
        recherche des profils correspondants et effectue en votre nom des
        actions (visite de profil, demande de connexion, invitation avec
        note, message direct) selon les paramètres et plages horaires que
        vous configurez.
      </>
    ),
  },
  {
    title: "3. Automatisation LinkedIn et responsabilité de l'utilisateur",
    body: (
      <>
        L'utilisation d'outils d'automatisation sur LinkedIn n'est pas
        officiellement approuvée par LinkedIn et peut être contraire à ses
        conditions d'utilisation. MmeValentine met en œuvre des mesures
        raisonnables pour limiter les cadences d'envoi et imiter un
        comportement humain, mais{" "}
        <strong>
          ne garantit en aucun cas l'absence de restriction, de limitation ou
          de suspension de votre compte LinkedIn
        </strong>
        . Vous reconnaissez utiliser le Service en connaissance de ce risque
        et restez seul responsable du respect des conditions d'utilisation de
        LinkedIn ainsi que des lois applicables (notamment en matière de
        prospection commerciale et de protection des données). MmeValentine
        ne pourra être tenue responsable des conséquences d'une action de
        LinkedIn sur votre compte, y compris sa suspension ou sa fermeture.
      </>
    ),
  },
  {
    title: "4. Compte et accès",
    body: (
      <>
        La création de compte et l'authentification sont gérées par notre
        prestataire <strong>Clerk</strong>. Vous êtes responsable de la
        confidentialité de vos identifiants et de toute activité réalisée
        depuis votre compte. Un compte LinkedIn ne peut être associé qu'à un
        seul compte MmeValentine à la fois ; toute tentative de changement de
        compte LinkedIn connecté peut être bloquée pour des raisons de
        sécurité.
      </>
    ),
  },
  {
    title: "5. Offres, abonnement et facturation",
    body: (
      <>
        Le Service propose une offre <strong>Freemium</strong> gratuite aux
        fonctionnalités limitées, et une offre <strong>Premium</strong> payante
        donnant accès à l'ensemble des fonctionnalités. La facturation des
        offres payantes est gérée via <strong>Clerk Billing</strong> ou, à
        défaut, sur devis après prise de contact. Les tarifs en vigueur sont
        indiqués sur notre page{" "}
        <a href="/pricing" className="text-rouge underline underline-offset-2">
          Tarifs
        </a>
        .
      </>
    ),
  },
  {
    title: "6. Annulation et résiliation",
    body: (
      <>
        Vous pouvez annuler votre abonnement Premium à tout moment depuis
        votre espace de facturation ; l'annulation prend effet à la fin de la
        période déjà payée, sans remboursement au prorata sauf disposition
        légale contraire. À l'issue de cette période, votre compte repasse
        automatiquement en offre Freemium. MmeValentine se réserve le droit
        de suspendre ou de résilier un compte en cas d'usage abusif, illicite
        ou contraire aux présentes CGU.
      </>
    ),
  },
  {
    title: "7. Données personnelles",
    body: (
      <>
        Le traitement de vos données personnelles et de celles issues de
        votre activité LinkedIn est décrit dans notre{" "}
        <a href="/confidentialite" className="text-rouge underline underline-offset-2">
          politique de confidentialité
        </a>
        .
      </>
    ),
  },
  {
    title: "8. Limitation de responsabilité",
    body: (
      <>
        Le Service est fourni « en l'état ». MmeValentine ne garantit pas de
        résultat commercial particulier (taux de réponse, nombre de
        connexions, etc.) et ne saurait être tenue responsable des dommages
        indirects résultant de l'utilisation du Service, y compris la perte
        d'accès à votre compte LinkedIn.
      </>
    ),
  },
  {
    title: "9. Modification des CGU",
    body: (
      <>
        Nous pouvons modifier les présentes CGU à tout moment. Les
        modifications prennent effet dès leur publication sur cette page. Il
        vous appartient de consulter régulièrement les CGU.
      </>
    ),
  },
  {
    title: "10. Contact et droit applicable",
    body: (
      <>
        Les présentes CGU sont soumises au droit français. Pour toute
        question, contactez-nous à{" "}
        <a href="mailto:support@activate.mmevalentine.com" className="text-rouge underline underline-offset-2">
          support@activate.mmevalentine.com
        </a>
        .
      </>
    ),
  },
];

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-cream font-sans flex flex-col">
      <PublicNav />

      <main className="flex-1 max-w-2xl w-full mx-auto px-4 lg:px-8 py-14">
        <div className="mb-10">
          <p className="type-label-accent">Document légal</p>
          <h1 className="mt-3 font-display text-3xl font-bold tracking-tight text-ink">
            Conditions générales d'utilisation
          </h1>
          <p className="mt-2 text-sm text-mute">Dernière mise à jour : {new Date().toLocaleDateString("fr-FR", { year: "numeric", month: "long" })}</p>
        </div>

        <div className="card p-8 space-y-8">
          {sections.map((s) => (
            <div key={s.title}>
              <h2 className="font-display font-semibold text-ink tracking-tight mb-2">
                {s.title}
              </h2>
              <p className="text-sm text-ink/70 leading-relaxed">{s.body}</p>
            </div>
          ))}
        </div>
      </main>

      <PublicFooter />
    </div>
  );
}
